import React from 'react';
import './mainscreen.css';
import {Outlet} from 'react-router-dom';
import {Locale} from 'antd/es/locale';
import MenuBar from '../../shared/menu/MenuBar.component';

interface MainScreenProps {
    t: (key: string) => string;
    changeLanguage: (language: string) => void;
    changeCurrentLocale: (locale: Locale) => void;
}

const MainScreen: React.FC<MainScreenProps> = ({t, changeLanguage, changeCurrentLocale}: MainScreenProps) => {

    return (
        <div className="main-screen__wrapper">

            <MenuBar t={t} changeLanguage={changeLanguage} changeCurrentLocale={changeCurrentLocale} />

            <div className="content__wrapper">
                <Outlet/>
            </div>

            {/*<div className="main-screen_footer__wrapper">*/}
            {/*    <PopoverComponent/>*/}
            {/*</div>*/}
        </div>
    )

}

export default MainScreen;
